/**
 * Clé stable pour React (slot_key prioritaire, ne change pas placeholder → vente).
 */
export function getPlanningRowKey(row) {
  if (row?.slot_key) {
    return row.slot_key;
  }
  if (row?.id != null) {
    return `id-${row.id}`;
  }
  const emplacement = row?.emplacement ?? row?.format ?? '';
  return `${row?.annee ?? ''}|${row?.semaine_date ?? row?.semaine ?? ''}|${emplacement}|${row?.web_slot_index ?? 1}`;
}

/**
 * Fusionne une ligne modifiée ou créée dans le tableau sans rechargement complet.
 *
 * @param {Array} prev
 * @param {object} row
 * @param {{ replaceKey?: string|number }} [options]
 */
export function mergePlanningRow(prev, row, options = {}) {
  if (!row) {
    return prev;
  }

  const replaceKey = options.replaceKey;
  const idx = prev.findIndex((item) => {
    if (row.id != null && item.id === row.id) {
      return true;
    }
    if (replaceKey != null && (item.slot_key === replaceKey || item.id === replaceKey)) {
      return true;
    }
    if (row.slot_key && item.slot_key === row.slot_key) {
      return true;
    }
    return false;
  });

  if (idx >= 0) {
    const next = [...prev];
    const slotKey = row.slot_key ?? prev[idx].slot_key;
    next[idx] = slotKey ? { ...row, slot_key: slotKey } : { ...row };
    return next;
  }

  return [...prev, { ...row }];
}

/**
 * Fusionne les lignes d'une semaine WEB (script Indispo inclus).
 *
 * @param {Array} prev
 * @param {Array} weekRows
 */
export function mergePlanningWeekRows(prev, weekRows) {
  if (!weekRows?.length) {
    return prev;
  }

  const weekKey = weekRows[0]?.semaine_date ?? weekRows[0]?.semaine ?? null;
  if (!weekKey) {
    return prev;
  }

  const nextWeekRows = weekRows.map((row) => ({ ...row }));
  const result = [];
  let inserted = false;

  for (const row of prev) {
    const rowWeekKey = row?.semaine_date ?? row?.semaine ?? null;
    if (rowWeekKey === weekKey) {
      if (!inserted) {
        result.push(...nextWeekRows);
        inserted = true;
      }
      continue;
    }

    result.push(row);
  }

  if (!inserted) {
    result.push(...nextWeekRows);
  }

  return result;
}

